export * from 'prosemirror-inputrules';
